import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { CookieService } from 'ngx-cookie';
import 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';

// import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { query } from '@angular/animations';
declare var require: any;
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { Location } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
import { ApiService } from './api.service';
import { environment } from 'environments/environment';
@Injectable()
export class SocketService {


  // Socket.io
  public socket: SocketIOClient.Socket;
  // public socketObs: BehaviorSubject<any>;
  public flightChangeEventData: BehaviorSubject<any> = new BehaviorSubject(null);
  public broadcastData: BehaviorSubject<any> = new BehaviorSubject(null);
  public editRoleData: BehaviorSubject<any> = new BehaviorSubject(null);
  public digitaltwinData: BehaviorSubject<any> = new BehaviorSubject(null);
  public digitaltwingateData: BehaviorSubject<any> = new BehaviorSubject(null);
  public equip_profile: BehaviorSubject<any> = new BehaviorSubject(null);
  public addFlightData: BehaviorSubject<any> = new BehaviorSubject(null);
  public editFlightData: BehaviorSubject<any> = new BehaviorSubject(null);
  public reopenFlightData: BehaviorSubject<any> = new BehaviorSubject(null);
  public alertsData: BehaviorSubject<any> = new BehaviorSubject(null);
  public allocationConflictFlghts: Subject<any> = new Subject<any>();
  public equipAllocation: Subject<any> = new Subject<any>();
  public aodbFlightUpdateData: Subject<any> = new Subject<any>();
  public mapviewFlightsUpdatedData: Subject<any> = new Subject<any>();
  public aodb_Schedules: Subject<any> = new Subject<any>();
  public resourceInfo : Subject<any> = new Subject<any>();
  public operatorProfile : Subject<any> = new Subject<any>();
  public equipmentProfile : Subject<any> = new Subject<any>();
  public mgt_add_edit_del : Subject<any> = new Subject<any>();
  public gse_add_edit_del : Subject<any> = new Subject<any>();
  public airlines_served_add_edit_del : Subject<any> = new Subject<any>();
  public pts_add_edit_del : Subject<any> = new Subject<any>();
  public shiftInfo : Subject<any> = new Subject<any>();
  public nonComplianceChangeEventData: BehaviorSubject<any> = new BehaviorSubject(null);
  public immersiveState: BehaviorSubject<any> = new BehaviorSubject(null);
  private sock;
  private socketpath;
  private socketconnection;
  private sockPath;
  public username;
  public entity;
  public name;
  public session;
  public operation_unit;
  public role;
  public acronym;
  public views;

  public host;
  public parameters;

  public bay_flight_icons;
  public default_turnaround_ops;

  show: Subject<boolean> = new Subject();
  public fetchAlerts = true;
  public alerts: any = [];
  public toastercounter = 0
  public temp = 1
  public totalOps = 0;
  public policies;
  route: string;
  public devid = ''
  public title = ''
  subscription
  browserRefresh
  gate;
  logid;
  langcode;



  constructor(
    private apiservice : ApiService,
    public http: HttpClient,
    location: Location, router: Router,
  ) {
    router.events.subscribe((val) => {
      if (location.path() != '') {
        this.route = location.path();

      }
    });
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.browserRefresh = !router.navigated;
        // console.log('browserRefresh', this.browserRefresh)
        if (this.browserRefresh) {
          this.SocketConnection();
        }

      }
    });
    // this.socketObs = new BehaviorSubject(null);

  }

  private extractdata(res) {
    return res;
  }

  getHost() {
    let socket = environment;
    this.sock = socket['socketHost'];
    this.host = socket['host'];
    this.socketpath = socket['socketconnection'];
  }


  public SocketConnection() {
    this.getHost();
    if (this.session != null || localStorage.getItem('Token')) {
      var routingkey;
       var socket = this.socket
          // this.socket.on('disconnect', function () {
          //   console.log('disconnected to server');
    
          // });
          // this.socket.emit('Connection', { 'routingkey': routingkey });
          // this.getAlert();
          // this.getChangeEvent(this.socket);
          // this.getBayAlert();  console.log('userProfile',JSON.parse(localStorage.getItem('userProfile')))
          // this.socket.on('error', function () {
          //   console.log('error')
          //   this.socket.connect();
          // });
          const session  = localStorage.getItem("Token")

          var socket = this.socket;
          // this.socket.on('connect', function (res) {
    
          //   if (socket) {
          //     socket.emit('Connection', { 'routingkey': routingkey });
          //   }
          // });
          // this.socket.on('disconnect', function () {
            // console.log('disconnected to server');
    
          // });
          // this.socket.on('error', function () {
          //   console.log('error')
          //   this.socket.connect();
          // });
          // this.editRole();
    }
  }

  connectsocket(){
    // console.log('calledsocket');
    let query = {
      user: 'web',
      'transports': ['websocket'],
      allowUpgrades: false,
      pingTimeout: 600000,
    }
    var self = this;
    // if (self.socket) {
    //   self.socket.disconnect();
    //   delete self.socket;
    //   self.socket = null;
    // }
    this.getHost();
    try {
      this.socket = io.connect(this.sock, { path: this.socketpath , query: query });
      if(this.socket){
        this.connectionsocket();
      }
    } catch (error) {
      if(error){
        this.socket.connect();
      }
    }
    
  }


  public connectionsocket(){
    var socket =  this.socket
    this.socket.on('connect', function (res) {
      if(socket){
        socket.emit('Connection');
        const gate = sessionStorage.getItem('gate') || '';
        const logid = sessionStorage.getItem('logid') || '';
        const lang = sessionStorage.getItem('langcode') || '';
        const sessionid = sessionStorage.getItem('sessionId')||'';
        const paxid = sessionid['value'];
        const view = window.innerHeight > innerWidth ? true : false;
        if(paxid){
          this.socket.emit('updaterefresh', {'session_id':paxid, 'view': !view ? 'Landscape' : 'Portrait',})
        }
        if(gate){
          if(socket && logid){
            socket.emit('airlinecomms', {'log_id':logid})
            console.log('emited');
          }
          let gatelist = []
          gatelist.push(gate)
          this.langcode = lang
          if(socket && gatelist.length){
            socket.emit('adrboardingstatus', {'gates': gatelist, 'language_code':lang})
          }
        }
      }
  });
  }

  public calldigitaltwin() {
    this.socket.emit('digitalTwin',{'digitalTwin': 'digitalTwin'})
    this.socket.on('digitalTwin', (data: any) => {
      this.digitaltwinData.next(data);
    });
  }

  public calldigitaltwine() {
    this.socket.emit('digitalTwinE',{'digitalTwinE': 'digitalTwinE'})
    this.socket.on('digitalTwinE', (data: any) => {
      const res = JSON.parse(JSON.stringify(data))
      this.apiservice.digitaltwinDatae.next(res);
    });
  }
  
  callgatedata(gate, langcode){
    this.gate = gate;
    this.langcode = langcode;
    if(gate){
      this.socket.emit('adrboardingstatus', {'gates': gate, 'language_code':langcode})
    }
    this.socket.on('adrboardingstatus', (data:any)=>{
      this.apiservice.digitaltwingateData.next(data);
    })
  }

  callnotofication(logid){
    this.logid = logid;
    if(logid){
      this.socket.emit('airlinecomms', {'log_id':this.logid})
    }
    this.socket.on('airlinecomms', (data:any)=>{
      this.apiservice.callnotification.next(data);
    })
  }

  public sentwatchcount(param){
    this.socket.emit('updaterefresh', {'session_id':param.pax_session_id, 'view':param.view})
  }


  public disconnectserver(){
    if(this.socket){
      this.socket.disconnect();
    }
  }

  // Get Changes Event
  getChangeEvent(socket) {
    socket.on('alert', (data: any) => {
      if (data.msg) {
        if (this.alertsData) {
          // this.alertsData.next(data.msg);
        }
        if (data.msg.type == 'Flight Information') {
          this.flightChangeEventData.next(data.msg);
        }
        else if (data.msg.type == 'NonCompliance') {
          this.nonComplianceChangeEventData.next(data.msg);
        }
      }
    });
  }


  public getSocket() {
    return this.socket;
  }

  // public getAlert() {


  //   this.socket.on('alert', (data: any) => {
  //     if (this.route == '/geofence') {
  //       this.show.next(true);
  //     }

  //     if (this.fetchAlerts) {
  //       let index = this.alerts.findIndex(x => x['deviceId'] == data.msg['deviceId'])
  //       //
  //       if (index === -1) {
  //         this.alerts.push(data.msg);
  //       }
  //       if (this.devid != data.msg['deviceId']) {
  //         this.devid = data.msg['deviceId'];
  //         this.toaster.show('warning', 'Geofencing' + '  alerts', data.msg['deviceId']);
  //       }
  //     }

  //   });
  // }


  public getCompletedActivities(operations) {
    let completedactivities = {};
    for (let operation of operations) {
      if (!(operation.code in completedactivities)) {
        completedactivities[operation.code] = 0;
      }
    }

    return Object.keys(completedactivities).length;
  }

  public getMarkedFlight(flight, message) {
    flight.markedby = message.markedby;
    if (message.newState == 'marked') {
      let arr = message.markedby[0].name.split(' ')
      if (arr.length == 1) {
        flight.markedby[0].acronym = (arr[0].slice(0, 3)).toUpperCase()
      }
      if (arr.length == 2) {
        flight.markedby[0].acronym = (arr[0].slice(0, 2) + arr[1].slice(0, 1)).toUpperCase()
      }
      if (arr.length >= 3) {
        flight.markedby[0].acronym = (arr[0].slice(0, 1) + arr[1].slice(0, 1) + arr[2].slice(0, 1)).toUpperCase()
      }
      flight.markedimp = true;
    }
    else if (message.newState == 'unmarked')
      flight.markedimp = false;
  }

  public flightFlagMessage(flightnoarr, logid, markedby) {

    let rkey = 'flightFlag.' + this.acronym.toString() + '.' + flightnoarr.slice(0, 2)
    if (markedby) {
      let message = {
        rkey: rkey,
        data: {
          flightnoarr: flightnoarr,
          logid: logid,
          markedby: markedby,
          newState: markedby.length == 0 ? 'unmarked' : 'marked',
          eventType: 'flight-flag'
        }
      }
      this.socket.emit('FlightFlag', message);
    }


  }

  public equipmentprofile() {
    this.socket.on('equipment_profile_updation', (data: any) => {
      this.equip_profile.next(data.msg);
    });
  }

  public broadcastMsg() {
    this.socket.on('broadcast', (data: any) => {

      if((this.views.indexOf("Pharma Alerts") != -1) && data.msg.hasOwnProperty('application') && data.msg.application == 'pharmaCargo') {
        if(data.msg.msg) {
          data.msg.msg = data.msg.msg.split(' DegreeC').join('°C');
        }
        this.broadcastData.next(data.msg);
      }

      if(!data.msg['application']) {
        // console.log('2')

        this.broadcastData.next(data.msg)
      }


    });
  }

  public editRole() {
    this.socket.on('editRole', (data: any) => {
      this.editRoleData.next(data.msg);
    });
  }

  public callofflivestatus(){
    this.socket.off('adrboardingstatus')
    this.socket.off('digitaltwin')
  }

  public newFlightLive() {
    this.socket.on('AddFlight', (data: any) => {
      this.addFlightData.next(data.msg);
    });
  }

  public getConflictFlights() {
    this.socket.on('AllocationConflict', (data: any) => {
      this.allocationConflictFlghts.next(data.msg)
    });
  }
  public getAllocation() {
    this.socket.on('flight-allocation', (data: any) => {
      this.equipAllocation.next(data);
    });

    this.socket.on('flight-updation', (data: any) => {
      this.equipAllocation.next(data);
    });

    this.socket.on('flight-deallocation', (data: any) => {
      this.equipAllocation.next(data);
    });

    this.socket.on('commonoperators-allocation', (data: any) => {
      this.equipAllocation.next(data);
    });

    this.socket.on('commonoperators-deallocation', (data: any) => {
      this.equipAllocation.next(data);
    });

    this.socket.on('equipment-allocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('equipment-deallocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('equipEnded', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('equipSharing', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline-equip-allocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline-equip-deallocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline_equipment_add', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline_equipment_delete', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline_repeat_allocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('airline_common_equip_allocation', (data: any) => {
      this.equipAllocation.next(data);
    });
    this.socket.on('flight_refresh', (data: any) => {
      this.equipAllocation.next(data);
    });


  }

  public aodbFlightUpdate() {
    this.socket.on('aodb', (data: any) => {
      this.aodbFlightUpdateData.next(data.msg)
    })
  }

  public mapviewFlightsUpdate() {
    this.socket.on('mapview-flights', (data: any) => {
      // console.log('mapview-flights', data);
      this.mapviewFlightsUpdatedData.next(data.msg)
    })
  }


  public manpower(){
    this.socket.on('', (data: any) => {
      this.aodbFlightUpdateData.next(data.msg)
    })
  }

  public aodbSchedules() {
    this.socket.on('aodbSchedules', (data: any) => {
      this.aodb_Schedules.next(data.msg);
    })
  }

  public editFlightLive() {
    this.socket.on('EditFlight', (data: any) => {
      this.editFlightData.next(data.msg);
    });
  }

  public reopenFlightLive() {
    this.socket.on('ReopenFlight', (data: any) => {
      this.reopenFlightData.next(data.msg.data);
    });
  }

  public resourcesLiveData() {
    this.socket.on('resource', (data: any) => {
      this.resourceInfo.next(data.msg);
    })
  }

  public operatorProfileLiveData() {
    this.socket.on('operatorProfile', (data: any) => {
      this.operatorProfile.next(data.msg);
    })
  }

  public equipmentProfileLiveData() {
    this.socket.on('equipmentProfile', (data: any) => {
      this.equipmentProfile.next(data.msg);
    })
  }
  public shiftManagementLiveData() {
    this.socket.on('shiftManagement', (data: any) => {
     this.shiftInfo.next(data.msg);
    })
  }

  public mgt_add_edit_del_live_data() {
    this.socket.on('mgt', (data: any) => {
      this.mgt_add_edit_del.next(data.msg);
    })
  }

  public gse_add_edit_del_live_data() {
    this.socket.on('gse', (data: any) => {
      this.gse_add_edit_del.next(data.msg);
    })
  }

  public airlines_served_add_edit_del_live_data() {
    this.socket.on('airlines_served', (data: any) => {
      this.airlines_served_add_edit_del.next(data.msg);
    })
  }

  public pts_add_edit_del_live_data() {
    this.socket.on('pts', (data: any) => {
      this.pts_add_edit_del.next(data.msg);
    })
  }

  public newActivity(operations, activity) {//insert
    for (let i = 0; i < operations.length; i++) {
      if (
        (operations[i].function == activity.function &&
          operations[i].equipmentid == activity.equipmentid &&
          operations[i].start == activity.start &&
          activity.end == null) ||
        (operations[i].function == activity.function && operations[i].equipmentid == null)
      ) {
        return false;
      }
    }
    return true;
  }

  public duplicateActivity(operations, activity) {
    for (let i = 0; i < operations.length; i++) {
      if (operations[i].function == activity.function &&
        operations[i].equipmentid == activity.equipmentid &&
        operations[i].start == activity.start &&
        operations[i].end == activity.end
      ) {
        return true;
      }
    }
    return false;
  }

  public updateActivity(turnaroundOperations, activity) {
    for (var j = 0; j < turnaroundOperations.operations.length; j++) { //started
      if (turnaroundOperations.operations[j].function == activity.function &&
        activity.remarkend == null
      ) {
        turnaroundOperations.operations[j].deviationend = activity.deviationend;
        turnaroundOperations.operations[j].deviatruetionstart = activity.deviationstart;
        turnaroundOperations.operations[j].durattrueion = activity.duration;
        // turnaroundOperations.operations[j].end = new Date(activity.end).toLocaleTimeString();
        turnaroundOperations.operations[j].equipmentid = activity.equipmentid;
        turnaroundOperations.operations[j].equipmentname = activity.equipmentname;
        turnaroundOperations.operations[j].equipmenttype = activity.equipmenttype;
        turnaroundOperations.operations[j].equipmenttypename = activity.equipmenttypename;
        turnaroundOperations.operations[j].remarkend = activity.remarkend;
        turnaroundOperations.operations[j].remarkstart = activity.remarkstart;
        turnaroundOperations.operations[j].start = new Date(activity.start).toLocaleTimeString();
        turnaroundOperations.operations[j].suggestedend = activity.suggestedend;
        turnaroundOperations.operations[j].suggestedstart = activity.suggestedstart;
        break;
      } else if (turnaroundOperations.operations[j].function == activity.function &&
        turnaroundOperations.operations[j].equipmentid == activity.equipmentid &&
        turnaroundOperations.operations[j].start == activity.start &&
        activity.remarkend != null
      ) {
        turnaroundOperations.operations[j].deviationend = activity.deviationend
        turnaroundOperations.operations[j].deviationstart = activity.deviationstart
        turnaroundOperations.operations[j].duration = Math.round((new Date(activity.end).valueOf() - new Date(activity.start).valueOf()) / 1000);
        turnaroundOperations.operations[j].end = new Date(activity.end).toLocaleTimeString();
        turnaroundOperations.operations[j].equipmentid = activity.equipmentid;
        turnaroundOperations.operations[j].equipmentname = activity.equipmentname;
        turnaroundOperations.operations[j].equipmenttype = activity.equipmenttype;
        turnaroundOperations.operations[j].equipmenttypename = activity.equipmenttypename;
        turnaroundOperations.operations[j].remarkend = activity.remarkend;
        turnaroundOperations.operations[j].remarkstart = activity.remarkstart;
        // turnaroundOperations.operations[j].start = activity.start;
        turnaroundOperations.operations[j].suggestedend = activity.suggestedend;
        turnaroundOperations.operations[j].suggestedstart = activity.suggestedstart;
        if (turnaroundOperations.count == null)
          turnaroundOperations.count = 0;

        turnaroundOperations.count = turnaroundOperations.count + 1;
        break;
      }
    }
  }

  public generateAlert(turnaroundoperations, activity, flightno) {
    if (activity.remarkend == null && activity.remarkstart == 'Late') {
      let info = activity.function + ' ' + activity.remarkstart + ' Start at ' + new Date(activity.start).toLocaleTimeString();
      let title = activity.remarkstart + ' ' + activity.function;
      let alert = {
        'info': info,
        'title': title
      }
      turnaroundoperations.alerts.push(alert)
      if (this.title != title) {
        this.title = title

      }


    } else if (activity.remarkend != null && activity.remarkend == 'Late') {
      let info = activity.function + ' ' + activity.remarkend + ' End by ' + Math.round((new Date(activity.end).valueOf() - new Date(activity.start).valueOf()) / 60000) + 'mins';
      let title = activity.remarkend + ' ' + activity.function;
      let alert = {
        'info': info,
        'title': title
      }
      turnaroundoperations.alerts.push(alert)

      if (this.title != title) {
        this.title = title

      }

    }
  }




  public getFlightActivity(flightno, operations) {
    // let opeartionFound = false;
    if (operations.msg.end == 'None' || operations.msg.end == '') {
      operations.msg.end = null;
    }

    if (this.newActivity(flightno.turnaroundoperations.operations, operations.msg)) {
      flightno.turnaroundoperations.operations.push(
        {
          'function': operations.msg.function,
          'code': operations.msg.code,
          'duration': operations.msg.duration,
          'group': operations.msg.group,
          'remarkstart': operations.msg.remarkstart,
          'end': operations.msg.end == null ? null : new Date(operations.msg.end).toLocaleTimeString(),
          'equipmentid': operations.msg.equipmentid,
          'start': new Date(operations.msg.start).toLocaleTimeString(),
          'remarkend': operations.msg.remarkend,
          'equipmentname': operations.msg.equipmentname,
          'deviationend': operations.msg.deviationend,
          'deviationstart': operations.msg.deviationstart,
          'equipmenttype': operations.msg.equipmenttype,
          'equipmenttypename': operations.msg.equipmenttypename,
          'suggestedend': operations.msg.suggestedend,
          'suggestedstart': operations.msg.suggestedstart,
        }
      );

      this.generateAlert(flightno.turnaroundoperations, operations.msg, flightno.flightnoarr);

      if (operations.msg.remarkend != null) {
        if (flightno.turnaroundoperations.count == null)
          flightno.turnaroundoperations.count = 0;

        flightno.turnaroundoperations.count = flightno.turnaroundoperations.count + 1;
      }

    } else if (!this.duplicateActivity(flightno.turnaroundoperations.operations, operations.msg)) {

      this.generateAlert(flightno.turnaroundoperations, operations.msg, flightno.flightnoarr);
      this.updateActivity(flightno.turnaroundoperations, operations.msg);
    }

  }


  public getAlertArray() {
    return this.alerts;
  }
  public setAlertArray(array) {
    this.alerts = array;
  }

  public startGettingAlerts(choice) {
    this.fetchAlerts = choice;
  }

  public disconnectSocket() {
    // this.socket ? this.socket.disconnect() : '';
  }

  getFlightIcons(host, parameters) {
    return this.http
      .get<any>(host + '/airportlocations', { params: parameters })
      .toPromise()
      .catch(err => { Promise.reject(err.message || err) });
  }



  // FORMAT THE MESSAGE RECIEVER VIA SOCKET TO THE APIN RESPONSE FORMAT



  public setMsgFormat(msg) {
    var new_state = msg['newState'];


    var airlineName = msg['airline'];
    //var airline = { "icon": img, "name": airlineName};
    var message;


    if (new_state == 'upcoming') {

      var rotation = 'rotation' in this.bay_flight_icons[msg.actualbay] ? this.bay_flight_icons[msg.actualbay]['rotation'] : null;
      var lat = this.bay_flight_icons[msg.actualbay]['lat'];
      var long = this.bay_flight_icons[msg.actualbay]['lng'];

      var flighticon = {
        'icon': null,
        'lat': lat,
        'lng': long,
        'rotation': rotation
      }

      var operations;
      var alert = [];

      operations = [];

      var turnaroundoperations = { 'alerts': alert, 'operations': operations, 'count': 0 };

      message = {
        'aircraft': { 'hexcode': msg['icao'] },
        'aircraft_state': 'Incoming',
        'airport': msg['airport'], //airport name
        'airline': msg['airline'],
        'bay': msg['actualbay'],
        'belt': null,
        'flightno': msg['flightnoar'],
        'flighticon': this.bay_flight_icons[msg['actualbay']],
        'flightnoarr': msg['flightnoar'],
        'flightnodep': '',
        'fromairport_iatacode': msg['fromairport_iatacode'],
        'toairport_iatacode': msg['toairport_iatacode'],

        //belt_firstbag: "",
        //belt_lastbaf: "",
        'sta': null,
        'std': null,
        'eta': msg['flightarrivaldate'] + ' ' + msg['eta'],
        'etd': null,
        'ata': null,
        'atd': null,
        'calc_ata_datetime': msg['flightarrivaldate'] + ' ' + msg['eta'],
        'eta_time': msg['flightarrivaldate'] + ' ' + msg['eta'],
        'scheduledturnaround': '45',
        'turnaroundoperations': turnaroundoperations,

        'sentTimestamp': msg['sentTimestamp'],
        'timeStamp': msg['timeStamp'],
        'eventId': msg['eventId'],
        'publisher': msg['publisher'],
        'eventType': msg['eventType'],
        'markedby': [
          {
            'name': null,
            'acronym': null,
            'comment': null,
            'email': null,
            'entity': null,
            'isActive': null,
            'lastname': null,
            'markedOn': null,
            'mobile': null,
            'firstname': null,
            'nickname': null
          }
        ],
        'markedimp': false,

        // "markedby": msg["markedby"],
        // "markedimp": msg["markedimp"],
        //"scheduledturnaround": msg["scheduledTurnaround"],
        'newState': msg['newState'],
        'deviceid': msg['deviceid'],
        'logid': msg['extra'].LogId,

      }
    }

    if (new_state == 'landed') {


      var rotation = 'rotation' in this.bay_flight_icons[msg.actualbay] ? this.bay_flight_icons[msg.actualbay]['rotation'] : null;
      var lat = this.bay_flight_icons[msg.actualbay]['lat'];
      var long = this.bay_flight_icons[msg.actualbay]['lng'];

      var flighticon = {
        'icon': null,
        'lat': lat,
        'lng': long,
        'rotation': rotation
      }

      var operations;
      var alert = [];

      operations = this.default_turnaround_ops;


      var turnaroundoperations = { 'alerts': alert, 'operations': operations, 'count': 0 };

      //If there's no flight departure number from the socket
      var atd = null;
      var etd = null;
      var std = null;
      var flightnodep = null;
      var toairport = null;
      var scheduledturnaround = null;
      var markedimp = false;
      var markedby_name = null;
      if (msg['extra'].FlightNumber_Departure !== undefined) {
        atd = msg['extra'].ATD;
        etd = msg['extra'].ETD;
        std = msg['extra'].STD;
        flightnodep = msg['extra'].FlightNumber_Departure;
        toairport = msg['extra'].ToAirport;
        scheduledturnaround = (new Date(msg['extra'].STD).valueOf() - new Date(msg['extra'].STA).valueOf()) / 60000;
        markedimp = msg['extra'].markedimp;
        markedby_name = msg['extra'].markedby_name;
      }

      message = {
        'airline': msg['airline'],
        'airport': msg['airport'], //airport name
        'aircraft_state': 'Taxi In',
        'eventId': msg['eventId'],
        'aircraft': { 'hexcode': msg['icao'] },
        // "logid": msg["extra"].LogId,
        'logid': msg['extra'].LogId_merged,
        'eventType': msg['eventType'],
        'bay': msg['actualbay'],
        'belt': msg['extra'].Belt,
        'flightnoarr': msg['flightnoar'],
        'flightnoarrr': msg['flightnoar'].slice(3),
        'flightnodep': flightnodep,
        'flightnodepp': flightnodep != null ? flightnodep.slice(3) : flightnodep,
        'fromairport_iatacode': msg['fromairport_iatacode'],
        'toairport_iatacode': msg['toairport_iatacode'],
        'fromairport': msg['extra'].FromAirport,
        'toairport': toairport,
        'bayIcon': this.bay_flight_icons[msg['actualbay']],
        'flighticon': flighticon,
        'turnaroundoperations': turnaroundoperations,
        'scheduledturnaround': scheduledturnaround,

        'sensor_ata': msg['extra'].Sensor_ATA,
        // "sensor_atd": msg["extra"].Sensor_ATD,

        'sta': msg['extra'].STA,
        'std': std,
        'eta': msg['extra'].ETA,
        // "eta": msg["flightarrivaldate"] + ' ' + msg["actualarrival"],
        'etd': etd,
        'ata': msg['flightarrivaldate'] + ' ' + msg['actualarrival'],
        'atd': atd,
        'ata_time': msg['actualarrival'],
        'calc_ata_time': msg['actualarrival'].slice(0, 5),
        'etd_time': msg['etd'],
        'calc_etd_time': new Date(msg['etd']).toLocaleTimeString().slice(0, 5),
        'calc_etd_datetime': msg['etd'],

        'sentTimestamp': msg['sentTimestamp'],
        'timeStamp': msg['timeStamp'],

        'markedby': [
          {
            'name': markedby_name,
            'acronym': null,
            'comment': null,
            'email': null,
            'entity': null,
            'isActive': null,
            'lastname': null,
            'markedOn': null,
            'mobile': null,
            'firstname': null,
            'nickname': null
          }
        ],
        'markedimp': markedimp,
        'newState': msg['newState'],
        'deviceid': msg['deviceid'],


      }

    }

    if (new_state == 'departed') {
      message = {
        'airline': msg['airline'],
        'aircraft': { 'hexcode': msg['icao'] },
        'aircraft_state': 'Departed',
        'airport': msg['airport'], //airport name
        'bay': null,
        'belt': null,
        'flightnoarr': null,
        'flightnodep': msg['flightnodep'],
        'fromairport_iatacode': msg['fromairport_iatacode'],
        'toairport_iatacode': msg['toairport_iatacode'],
        'markedby': [
          {
            'name': null,
            'acronym': null,
            'comment': null,
            'email': null,
            'entity': null,
            'isActive': null,
            'lastname': null,
            'markedOn': null,
            'mobile': null,
            'firstname': null,
            'nickname': null
          }
        ],
        'sta': '',
        'std': '',
        'eta': '',
        'etd': '',
        'ata': '',
        'atd': msg['flightdeparturedate'] + ' ' + msg['actualdeparture'],
        'departureTime': msg['flightdeparturedate'] + ' ' + msg['actualdeparture'],
        'sentTimestamp': msg['sentTimestamp'],
        'actualdeparture': msg['actualdeparture'],
        'timeStamp': msg['timeStamp'],
        'markedimp': false,
        'newState': msg['newState'],
        'deviceid': msg['deviceid'],
        'eventId': msg['eventId'],
        'eventType': msg['eventType'],
        'logid': msg['extra'].LogId,

        //"bayIcon": bay_flight_icons[msg["actualbay"]]
      }

    }


    return message;

  }


  ngOnInit() {

  }

}
